import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NavigationHint = ({ onNext, onPrev, canGoNext, canGoPrev, hasInteracted }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2, ease: [0.25, 0.1, 0.25, 1] }}
      className="fixed bottom-8 sm:bottom-10 left-0 right-0 flex flex-col items-center gap-4 sm:gap-6 z-20"
    >
      {/* Keyboard/swipe hint - only show if not interacted yet */}
      {!hasInteracted && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 0.5, y: 0 }}
          transition={{ delay: 1, duration: 1.5 }}
          className="text-xs sm:text-sm tracking-widest uppercase font-body cursor-pointer"
          style={{ color: 'hsl(40, 8%, 50%)' }}
          onClick={onNext}
        >
          <span className="hidden sm:inline">Click or use arrow keys to continue</span>
          <span className="sm:hidden">Tap to continue</span>
        </motion.p>
      )}

      {/* Navigation buttons - larger and more visible */}
      <div className="flex items-center gap-8 sm:gap-6">
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          disabled={!canGoPrev}
          className="w-14 h-14 sm:w-12 sm:h-12 rounded-full hover:bg-vaulten-ink/50 disabled:opacity-20 disabled:hover:bg-transparent transition-all duration-500 border border-transparent hover:border-vaulten-ash/20"
          style={{ color: canGoPrev ? 'hsl(40, 10%, 55%)' : 'hsl(40, 5%, 25%)' }}
          aria-label="Previous scene"
        >
          <ChevronLeft className="w-6 h-6" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          disabled={!canGoNext}
          className="w-14 h-14 sm:w-12 sm:h-12 rounded-full hover:bg-vaulten-ink/50 disabled:opacity-20 disabled:hover:bg-transparent transition-all duration-500 border border-transparent hover:border-vaulten-ash/20"
          style={{ color: canGoNext ? 'hsl(40, 10%, 55%)' : 'hsl(40, 5%, 25%)' }}
          aria-label="Next scene"
        >
          <ChevronRight className="w-6 h-6" />
        </Button>
      </div>
    </motion.div>
  );
};

export default NavigationHint;
